import { Cartographic, ScreenSpaceEventHandler, Math as MathCesium, ScreenSpaceEventType } from 'cesium';
import '../styles/footerView.css'
import logoDPU from '../assets/images/dpu_logo2.png'
// let logoDPU = 'https://unpkg.com/beta-test-view@0.0.10/dist/assets/images/dpu_logo2.png'

import { IconMinus, IconPlus } from '../icon';
import { getMessage } from '../language';

export class FooterViewer {
    viewer: any;
    containerId: string;

    constructor(containerId: string, viewer: any,) {
        this.containerId = containerId; // Gán giá trị containerId    
        this.viewer = viewer;//Gán giá trị viewer
        this.createFooter()
        this.createZoomBtn();
    }

    private createFooter = () => {
        // Lấy đối tượng container theo ID
        const containerId = document.querySelector(`#${this.containerId}`);
        const containerCesium = containerId?.querySelector('.cesium-viewer')
        if (containerCesium) {
            // Tạo thẻ div chứa footer info
            const footerInfoContainer = document.createElement('div');
            footerInfoContainer.classList.add('footer-info-container');
            footerInfoContainer.addEventListener('click', () => {
                // Lấy vị trí camera (là một đối tượng Cartesian3)
                const cameraPosition = this.viewer.camera.positionWC;  // Vị trí camera trong hệ tọa độ thế giới (World Coordinate)

                // Chuyển từ Cartesian3 sang Cartographic (Longitude, Latitude, Altitude)
                const cartographicPosition = Cartographic.fromCartesian(cameraPosition);

                // Lấy kinh độ, vĩ độ và độ cao (altitude)
                var longitude = MathCesium.toDegrees(cartographicPosition.longitude); // Chuyển từ radian sang độ
                var latitude = MathCesium.toDegrees(cartographicPosition.latitude); // Chuyển từ radian sang độ

                const objClipboard = {
                    longitude: longitude,
                    latitude: latitude,
                    height: this.heightCamera,
                    angle: this._angleDev,
                    pitch: this._pitchDev
                };
                const jsParse = JSON.stringify(objClipboard, null, 2)

                navigator.clipboard.writeText(jsParse)
            });
            // Tạo các phần tử con bên trong footer
            const footerImg = document.createElement('div');
            footerImg.classList.add('footer-info-content');

            footerImg.innerHTML = `
                <img src="${logoDPU}" alt="DP-Unity"/>
            `
            footerInfoContainer.appendChild(footerImg);

            // Tạo các phần tử con bên trong footer
            const footerInfoContent1 = document.createElement('div');
            footerInfoContent1.classList.add('footer-info-content');
            footerInfoContent1.innerHTML = `${getMessage("footer-angle")}: <span id="${this.containerId}-angle"> 0</span>`;

            const footerInfoContent2 = document.createElement('div');
            footerInfoContent2.classList.add('footer-info-content');
            footerInfoContent2.innerHTML = `${getMessage("footer-tilt")}: <span id="${this.containerId}-pitch"> 0</span>`;

            const footerInfoContent3 = document.createElement('div');
            footerInfoContent3.classList.add('footer-info-content');
            footerInfoContent3.innerHTML = `${getMessage("footer-elevation")}: <span id="${this.containerId}-elevation"> 0</span>`;

            const footerInfoContent4 = document.createElement('div');
            footerInfoContent4.classList.add('footer-info-content');
            footerInfoContent4.innerHTML = `${getMessage("footer-longitude")}: <span id="${this.containerId}-longitude"> 0</span>`;

            const footerInfoContent5 = document.createElement('div');
            footerInfoContent5.classList.add('footer-info-content');
            footerInfoContent5.innerHTML = `${getMessage("footer-latitude")}: <span id="${this.containerId}-latitude"> 0</span>`;

            // Thêm các phần tử con vào trong footerInfoContainer
            footerInfoContainer.appendChild(footerInfoContent1);
            footerInfoContainer.appendChild(footerInfoContent2);
            footerInfoContainer.appendChild(footerInfoContent3);
            footerInfoContainer.appendChild(footerInfoContent4);
            footerInfoContainer.appendChild(footerInfoContent5);

            // Thêm footerInfoContainer vào trong containerId
            containerCesium.appendChild(footerInfoContainer);
            this.initializeMouseHandler()
            // this.callInitializeMouseHandlerAfterDelay()
            this.startCameraUpdate()
        } else {
            console.error(`Container with ID "${this.containerId}" not found.`);
        }
    }

    //#region convertDEGToDMS
    private convertDEGToDMS = (deg: number, isLat: boolean) => {
        const absolute = Math.abs(deg);

        const degrees = Math.floor(absolute);
        const minutesNotTruncated = (absolute - degrees) * 60;
        const minutes = Math.floor(minutesNotTruncated);
        const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(2);

        let minSec = '';
        if (minutes || seconds !== '0.00') minSec += minutes + "'";
        if (seconds !== '0.00') minSec += seconds + '"';

        return `${degrees}°${minSec.padStart(2, '0')} ${isLat ? (deg >= 0 ? 'N' : 'S') : deg >= 0 ? 'E' : 'W'
            }`;
    }

    private longitudeFooter: string = "0"
    private latitudeFooter: string = "0"

    //#region initializeMouseHandler
    private initializeMouseHandler = () => {
        // Tạo handler cho sự kiện chuột
        const handlerInitMouseEdge = new ScreenSpaceEventHandler(this.viewer.canvas);

        handlerInitMouseEdge.setInputAction((movement: any) => {
            // Lấy vị trí chuột trên bản đồ
            const cartesian = this.viewer.camera.pickEllipsoid(movement.endPosition);
            if (cartesian) {
                // Chuyển đổi toạ độ Cartesian2 thành lon/lat
                const cartographic = Cartographic.fromCartesian(cartesian);

                // Chuyển từ radians sang degrees
                const long = MathCesium.toDegrees(cartographic.longitude);
                const lat = MathCesium.toDegrees(cartographic.latitude);

                // Cập nhật giá trị vào các thẻ span
                this.longitudeFooter = this.convertDEGToDMS(long, false);
                this.latitudeFooter = this.convertDEGToDMS(lat, true);
            }
        }, ScreenSpaceEventType.MOUSE_MOVE);
    }
    //#endregion initializeMouseHandler
    // Hàm chuyển đổi miter (đơn vị chiều cao) sang chuỗi
    private miterToStr = (miter: number) => {
        if (!miter) return '0m';
        if (miter > 10000) {
            return (miter / 1000).toFixed(2) + ' km';
        } else {
            return miter.toFixed(2) + ' m';
        }
    }
    //#region startCameraUpdate
    private startCameraUpdate = () => {
        // Lắng nghe sự kiện `onTick` của Cesium
        this.viewer.clock.onTick.addEventListener(() => {
            this.updateCameraParams(); // Gọi hàm cập nhật các tham số camera
        });
    }


    //#region  updateCameraParams
    private heightCamera: number = 0
    private _pitchDev: any
    private _angleDev: any
    // Hàm để lấy thông tin camera và cập nhật UI
    private updateCameraParams = () => {
        const camera = this.viewer.camera;

        // Lấy các tham số cần thiết
        this.heightCamera = camera.positionCartographic.height;
        this._pitchDev = camera.pitch; // Lấy giá trị pitch
        this._angleDev = camera.heading; // Lấy giá trị heading
        const pitch = MathCesium.toDegrees(camera.pitch); // Chuyển sang độ
        let angle = MathCesium.toDegrees(camera.heading); // Chuyển sang độ
        if (angle > 180) {
            angle = angle - 360; // Điều chỉnh nếu angle vượt quá 180
        }

        // Cập nhật giá trị vào DOM
        const elevationEl = document.getElementById(`${this.containerId}-elevation`);
        if (elevationEl) elevationEl.innerText = this.miterToStr(this.heightCamera);

        const angleEl = document.getElementById(`${this.containerId}-angle`);
        if (angleEl) angleEl.innerText = this._angleDev.toFixed(2) + "°";

        const pitchEl = document.getElementById(`${this.containerId}-pitch`);
        if (pitchEl) pitchEl.innerText = pitch.toFixed(2) + "°";

        // Cập nhật giá trị vào các thẻ span
        const longitudeEl = document.getElementById(`${this.containerId}-longitude`);
        if (longitudeEl) longitudeEl.textContent = this.longitudeFooter;

        const latitudeEl = document.getElementById(`${this.containerId}-latitude`);
        if (latitudeEl) latitudeEl.textContent = this.latitudeFooter;
    }

    //#region  createZoomBtn
    private createZoomBtn = () => {
        // Lấy đối tượng container theo ID
        const containerId = document.querySelector(`#${this.containerId}`);

        if (containerId) {
            // Tìm phần tử con có class 'cesium-viewer' trong container
            const viewerElement = containerId.querySelector('.cesium-viewer');
            // Tạo toolbar chính

            const zoomIn = document.createElement('div');
            zoomIn.className = 'zoom-earth in';
            // Tạo các nhóm button
            zoomIn.innerHTML = `
             <button id="group-earth-zoom-${this.containerId}" class="container-tool-cesium" style="margin-top: 5px">
                  <div id="earth-zoom-in-${this.containerId}" class="btn-tool-cesium">${IconPlus()}</div>
             </button>
            `
            const zoomOut = document.createElement('div');
            zoomOut.className = 'zoom-earth out';
            // Tạo các nhóm button
            zoomOut.innerHTML = `
             <button id="group-earth-zoom-${this.containerId}" class="container-tool-cesium" style="margin-top: 5px">
                  <div id="earth-zoom-out-${this.containerId}" class="btn-tool-cesium" >${IconMinus()}</div>
             </button>
            `
            // Thêm toolbar vào viewer
            viewerElement!.appendChild(zoomIn);
            viewerElement!.appendChild(zoomOut);

            const btnZoomIn = zoomIn.querySelector(`#earth-zoom-in-${this.containerId}`);
            if (btnZoomIn) {
                btnZoomIn.addEventListener('click', () => this.handleZoomEarth(true))
            }

            const btnZoomOut = zoomOut.querySelector(`#earth-zoom-out-${this.containerId}`);
            if (btnZoomOut) {
                btnZoomOut.addEventListener('click', () => this.handleZoomEarth(false))
            }

        }
    }

    //#region handleZoomEarth
    private handleZoomEarth = (zoom: boolean) => {
        const newHeightCam = this.heightCamera / 2
        if (zoom) {
            this.viewer.camera.zoomIn(newHeightCam)
        } else {
            this.viewer.camera.zoomOut(newHeightCam)
        }
    }

}